import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import ScrollToTop from './components/ScrollToTop';

// Import all page components
import Homepage from './pages/homepage';
import Registration from './pages/registration';
import Login from './pages/Login';
import CollectionDashboard from './pages/collection-dashboard';
import AddCollection from './pages/add-collection';
import CollectionDetail from './pages/collection-detail';
import MarketAnalysis from './pages/market-analysis';
import ProfileManagement from './pages/profile-management';
import NewsFeed from './pages/news-feed';
import ComingSoon from './pages/coming-soon';
import NotFound from './pages/NotFound';
import SystemSettings from './pages/system-settings';
import AdminPortal from './pages/admin-portal';
import HelpSupport from './pages/help-support';
import PublicCollection from './pages/public-collection';
import AdvancedDashboard from './pages/advanced-dashboard';
import MarketplaceDashboard from './pages/marketplace';
import SellerAuctionDashboard from './pages/seller-auction-dashboard';
import BuyerAuctionDashboard from './pages/buyer-auction-dashboard';
import AdminModerationDashboard from './pages/admin-moderation';
import CheckoutConfirmation from './pages/checkout-confirmation';
import PortfolioPerformance from './pages/portfolio-performance';
import AuctionFloor from './pages/auction-floor';
import Checkout from './pages/checkout';

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center p-8">
        <h2 className="text-2xl font-bold text-foreground mb-4">Something went wrong</h2>
        <p className="text-muted-foreground mb-4">{error?.message}</p>
        <button 
          onClick={resetErrorBoundary}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/public-collection" element={<PublicCollection />} />
          
          {/* Protected Routes - In Rocket Platform Development Mode, all routes are accessible */}
          <Route path="/collection-dashboard" element={<CollectionDashboard />} />
          <Route path="/advanced-dashboard" element={<AdvancedDashboard />} />
          <Route path="/marketplace" element={<MarketplaceDashboard />} />
          <Route path="/auction-floor" element={<AuctionFloor />} />
          <Route path="/seller-auction-dashboard" element={<SellerAuctionDashboard />} />
          <Route path="/buyer-auction-dashboard" element={<BuyerAuctionDashboard />} />
          <Route path="/admin-moderation" element={<AdminModerationDashboard />} />
          <Route path="/add-collection" element={<AddCollection />} />
          <Route path="/collection-detail" element={<CollectionDetail />} />
          <Route path="/market-analysis" element={<MarketAnalysis />} />
          <Route path="/profile-management" element={<ProfileManagement />} />
          <Route path="/news-feed" element={<NewsFeed />} />
          <Route path="/help-support" element={<HelpSupport />} />
          <Route path="/checkout-confirmation" element={<CheckoutConfirmation />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/portfolio-performance" element={<PortfolioPerformance />} />
          
          {/* Admin Routes */}
          <Route path="/system-settings" element={<SystemSettings />} />
          <Route path="/admin-portal" element={<AdminPortal />} />
          
          {/* Catch all route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;